// extracted by mini-css-extract-plugin
export default {"timer":"PomodoroTimer_timer__CkrVa"};